// src/components/ArticleCard.js
import React from "react";
import { useSwipeable } from "react-swipeable";

import { useTheme } from "../context/ThemeContext";
import { spacing } from "../utils/tokens";
import Typography from "./Typography";
import { Headphones, BookmarkSimple } from "@phosphor-icons/react";


import Divider from "./Divider";

function ArticleCard({ key, article, onSwipeRight }) {

  const { theme } = useTheme(); 
  
  const handlers = useSwipeable({
    onSwipedRight: () => {
      if (onSwipeRight) {
        onSwipeRight();
      }
    },
  });

  const styles = {
      cardContainer:{
        display: "flex",
        flexDirection: "column",
        gap: spacing.xxxs,
        width: "100%",
        height: "fit-content",
        backgroundColor: theme.colors.background,
        color: theme.colors.contentPrimary,
        padding: spacing.xxxs,
        boxSizing: "border-box",
      },
      card: {
        display: "flex",
        flexDirection: "column",
        gap: spacing.m,
        width: "100%",
        height: "fit-content",
        backgroundColor: theme.colors.background,
        color: theme.colors.contentPrimary,
        padding: spacing.m,
        boxSizing: "border-box",
      },
      textGroup: {
        display: "flex",
        flexDirection: "column",
        gap: spacing.s,
      },
      actionsContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: spacing.s,
      },
      iconsContainer:{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: spacing.m,
      }

  };
  

  return (

    <div
      {...handlers}
      style={styles.cardContainer}
    >
      <div style={styles.card}>
        <div style={styles.textGroup}>
          <Typography variant="label" type="utility" style={{ color: theme.colors.contentSecondary }}>DEFAULT</Typography>
          <Typography variant="headlineM" type="editorial" style={{ color: theme.colors.contentPrimary }}>{article.title}</Typography>
          <Typography variant="summary" type="editorial" style={{ color: theme.colors.contentPrimary }}>{article.description}</Typography>
        </div>
        <img src={article.urlToImage} alt={article.title} style={{ width: "100%", height: "auto" }} />
        <div style={styles.actionsContainer}>
          <Typography variant="supportingCaption" type="editorial" style={{ color: theme.colors.contentSecondary, width: "100%" }}>6 min read</Typography>
          <div style={styles.iconsContainer}>
            <Headphones size={24} color={theme.colors.contentSecondary}/>
            <BookmarkSimple size={24} color={theme.colors.contentSecondary}/>
          </div>
        </div>
      </div>
      
      <Divider />

      {/* {onSwipeRight && <p style={{ fontStyle: "italic" }}>Add to Queue</p>} */}
    </div>
  );
}

export default ArticleCard;